// Deterministic color per "unit" (the company name saved on a user's floor
// plan details) so seats sharing a unit get a matching border/legend color.

// Sentinel "unit" used for remote users who aren't part of any company/team.
export const NO_TEAM_UNIT = 'No Team';

const UNIT_COLOR_PALETTE = [
    '#1976D2', '#43A047', '#FB8C00', '#8E24AA', '#E53935',
    '#00897B', '#3949AB', '#D81B60', '#6D4C41', '#546E7A',
];

function hashString(value) {
    let hash = 0;
    for (let i = 0; i < value.length; i++) {
        hash = (hash * 31 + value.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
}

export function getUnit(user) {
    return user && user.floor_plan_detail && user.floor_plan_detail.unit ? user.floor_plan_detail.unit : null;
}

export function unitColor(unitName) {
    if (!unitName) return null;
    if (unitName === NO_TEAM_UNIT) return '#9E9E9E';
    return UNIT_COLOR_PALETTE[hashString(unitName) % UNIT_COLOR_PALETTE.length];
}
